
export class Highlight {
  index = -1
  count = 0

  constructor (
    private render: () => void
  ) {}

  setCount = (count: number) => {
    this.count = count
    if (this.index >= count) {
      this.index = -1
    }
  }

  next = () => {
    let nextIndex = this.index + 1
    if (nextIndex >= this.count) {
      nextIndex = 0
    }

    this.index = nextIndex
    this.render()
  }

  prev = () => {
    let nextIndex = this.index - 1
    if (nextIndex < 0) {
      nextIndex = this.count - 1
    }

    this.index = nextIndex
    this.render()
  }

  setIndex = (nextIndex: number) => {
    if (nextIndex >= this.count) {
      this.index = -1
    } else {
      this.index = nextIndex
    }

    this.render()
  }
}
